// @flow

import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  #tectonics {
    font-size: 14px;
    font-family: "Noto Sans", OpenSans, Arial, "Helvetica Neue", Helvetica, sans-serif;
    color: #2f4a75;
    background-color: #dfe3e8;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  @keyframes lost-in-space-object {
    0% { transform: translate( 0%,-15%) rotate( 0deg); }
    20% { transform: translate( 5%,  0%) rotate(-3deg); }
    50% { transform: translate( 0%, 15%) rotate(-6deg); }
    75% { transform: translate( 5%,  0%) rotate(-3deg); }
    100% { transform: translate( 0%,-15%) rotate( 0deg); }
  }
`;
